<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="标题">
      <a-input v-model="form.data.title" prop="title" />
    </a-form-model-item>
    <a-form-model-item label="标题英文">
      <a-input v-model="form.data.titleEn" prop="titleEn" />
    </a-form-model-item>
    <a-form-model-item label="编码">
      <a-input v-model="form.data.code" prop="code" :disabled="disable" />
    </a-form-model-item>
    <a-form-model-item label="内容" v-if="form.data.type==='HTML'">
      <html-editor v-model="form.data.content"/>
    </a-form-model-item>
    <a-form-model-item label="内容" v-if="form.data.type==='TEXT'">
       <a-textarea v-model="form.data.content" allow-clear :autosize="{ minRows:6 }"/>
    </a-form-model-item>
    <a-form-model-item label="内容英文" v-if="form.data.type==='TEXT'">
      <a-textarea v-model="form.data.contentEn" allow-clear :autosize="{ minRows:6 }"/>
    </a-form-model-item>
    <a-form-model-item label="描述" v-if="form.data.type==='SIZE'">
      <a-textarea v-model="form.data.description" style="height: 100px"/>
    </a-form-model-item>
    <a-form-model-item label="描述英文" v-if="form.data.type==='SIZE'">
      <a-textarea v-model="form.data.descriptionEn" style="height: 100px"/>
    </a-form-model-item>
    <a-form-model-item label="内容" v-if="form.data.type==='IMAGE'">
      <div class="a-input">
        <simple-uploader v-model="form.data.content"/>
      </div>
    </a-form-model-item>

    <a-form-model-item>
      <a-space>
        <a-button type="primary" v-if="!appInfoId" @click="onAdd">创建</a-button>
        <a-button type="primary" v-if="appInfoId" @click="onUpdate">更新</a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _queryAppInfo,
  _addAppInfo,
  _updateAppInfo,
} from '@/api/appInfoApi';
import HtmlEditor from '../../../components/HtmlEditor.vue';
import SimpleUploader from '../../../components/SimpleUploader.vue';

async function getAppInfo() {
  const result = await _queryAppInfo(this.appInfoId);
  if (result) {
    this.form.data.title = result.title;
    this.form.data.content = result.content;
    this.form.data.code = result.code;
    this.form.data.type = result.type;
    this.form.data.description = result.description;
    this.form.data.contentEn = result.contentEn;
    this.form.data.descriptionEn = result.descriptionEn;
    this.form.data.titleEn = result.titleEn;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addAppInfo({
        title: this.form.data.title,
        content: this.form.data.content,
        code: this.form.data.code,
        type: this.form.data.type,
        description: this.form.data.description,
        contentEn: this.form.data.contentEn,
        descriptionEn: this.form.data.descriptionEn,
        titleEn: this.form.data.titleEn,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateAppInfo(this.appInfoId, {
        title: this.form.data.title,
        content: this.form.data.content,
        code: this.form.data.code,
        type: this.form.data.type,
        description: this.form.data.description,
        contentEn: this.form.data.contentEn,
        descriptionEn: this.form.data.descriptionEn,
        titleEn: this.form.data.titleEn,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'AppInfoEdit',
  components: {
    SimpleUploader,
    HtmlEditor,
  },
  props: {
    appInfoId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    appInfoId() {
      if (this.appInfoId) {
        this.getAppInfo();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getAppInfo,
  },
  data() {
    return {
      disable: false,
      form: {
        data: {
          title: '',
          content: '',
          code: '',
          type: 'SIZE',
          description: '',
          contentEn: '',
          descriptionEn: '',
          titleEn: '',
        },
        rules: {
          title: [{ required: true, trigger: 'blur' }],
          code: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
    };
  },
  created() {
    if (this.appInfoId) {
      this.getAppInfo();
      this.disable = true;
    }
  },
};
</script>
